import { useCallback } from 'react';
import { API } from './api';

const getDeviceType = () => {
  const w = window.innerWidth;
  if (w < 768) return 'mobile';
  if (w < 1024) return 'tablet';
  return 'desktop';
};

export function useTrackCTA() {
  const track = useCallback((eventName, destination = '', abMeta = {}) => {
    try {
      const payload = {
        event_name: eventName,
        source_page: window.location.pathname,
        element_id: eventName,
        destination,
        device_type: getDeviceType(),
        referrer: document.referrer || '',
        ab_test_id: abMeta.testId || '',
        variant_id: abMeta.variantId || '',
      };
      // Fire-and-forget — don't block the UI
      navigator.sendBeacon?.(
        `${API}/analytics/track`,
        new Blob([JSON.stringify(payload)], { type: 'application/json' })
      ) || fetch(`${API}/analytics/track`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true,
      }).catch(() => {});
    } catch {
      // Silent fail — analytics should never break the app
    }
  }, []);

  return track;
}
